import config from "utils/globals";

export const getNavigationData = (instance) => {
  return instance()
    .get(`/general/api/v1/navigation/`)
    .then((response) => {
      return config.sortArray(response?.data, "priority");
    });
};
